import { OrderType } from './order-type';

export interface BdoStatement {
	id: number;
	orderId: number;
	orderType: OrderType.classic | OrderType.loose;
	number: number;
	numberYear: number;
	wasteCode: string;
	wasteName: string;
	pickupAddress: string;
	companyName: string;
	registeredAddress: string;
	nipPesel: string;
	signedPlace: string;
	signedDate: string;
	signature: string | null;
	signedAt: string | null;
	createdAt: string;
	createdBy: number;
}

export const getReadableStatementNumber = (s: BdoStatement): string => {
	if (s.numberYear !== null && s.number !== null) {
		return `OŚW/${s.numberYear}/${s.number}`;
	}

	return '';
};
